import { useEffect } from "react";
import { RouterProvider } from "react-router-dom";
import "./App.scss";
import { useAuth } from "./auth/useAuth";
import appRouter from "./components/router/AppRouter";
import useResizeObserver from "./hooks/useResizeObserver";
import { dayjsSetup } from "./helpers/dayjs.helper";
import { LoadingOverlay } from "./components/ui-lib/LoadingOverlay";
import { useGlobalState } from "./states/global-state/global.state";
import { Helmet } from "react-helmet";

function App() {
  dayjsSetup();
  const size = useResizeObserver();
  const { initialized } = useAuth();
  const {
    globalState: { isLoading },
  } = useGlobalState();

  const { autoLogin } = useAuth();

  useEffect(() => {
    const scrollbarWidth = window.innerWidth - document.body.clientWidth;
    document.documentElement.style.setProperty(
      "--scrollbarWidth",
      `${scrollbarWidth}px`,
    );
  }, [size]);

  useEffect(() => {
    autoLogin();
  }, [autoLogin]);

  return (
    <>
      <Helmet>
        <meta name="keywords" content="Stellenvermittlung, Schule, Lehrer" />
        <meta name="author" content="Severin Haas, Jan Kuonen, Lea Burki" />
        <meta
          name="description"
          content="Stellenvermittlung in Primarschulen"
        />
      </Helmet>
      {initialized ? (
        <LoadingOverlay isLoading={isLoading}>
          <RouterProvider router={appRouter}></RouterProvider>
        </LoadingOverlay>
      ) : (
        <LoadingOverlay isLoading={true} />
      )}
    </>
  );
}

export default App;
